<template>
  <v-dialog v-model="previewSeriesDialog" width="700" persistent>
    <v-card>
      <v-card-title
        class="headline lighten-2 justify-content-between"
        primary-title
      >
        Preview Series
        <v-btn
          @click="togglePreviewDialog"
          color="error"
          class="float-right"
          text
        >
          <v-icon x-small>fas fa-times m-1</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-expansion-panels class="px-5" focusable style="width: 100%">
        <v-expansion-panel v-for="(singleSeries, index) in series">
          <v-expansion-panel-header>
            <v-row style="width: 100%">
              <v-col cols="6">
                <span class="small text-uppercase">{{
                  singleSeries.name
                }}</span>
              </v-col>
              <v-col cols="5">
                <v-chip
                  v-if="singleSeries.user_progress.units_left == '0'"
                  class="mb-2"
                  color="success"
                  label
                  dark
                  x-small
                >
                  <v-avatar left x-small class="success">
                    <v-icon x-small>fas fa-badge-check m-1</v-icon>
                  </v-avatar>
                  Certified
                </v-chip>
              </v-col>
              <v-col cols="1"></v-col>
            </v-row>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                cols="12"
                v-for="(unit, index) in singleSeries.units"
                class="row position-relative"
                :key="index"
              >
                <div>
                  <router-link
                    :to="{
                      name: 'UnitPage',
                      params: { id: unit.unit.id },
                    }"
                  >
                    <h5>
                      {{ unit.unit.name }}
                      <v-chip
                        v-if="unit.unit.is_completed"
                        class="mb-2"
                        color="success"
                        label
                        dark
                        x-small
                      >
                        <v-avatar left x-small class="success">
                          <v-icon x-small>fas fa-badge-check m-1</v-icon>
                        </v-avatar>
                        Completed
                      </v-chip>
                      <v-chip
                        v-else-if="unit.unit.is_finished_watching"
                        class="mb-2"
                        color="info"
                        label
                        dark
                        x-small
                      >
                        <v-avatar left x-small class="info">
                          <v-icon x-small>fal fa-tv</v-icon>
                        </v-avatar>
                        Watched
                      </v-chip>
                      <v-chip
                        v-else-if="unit.unit.is_video_played"
                        class="mb-2"
                        color="default"
                        label
                        dark
                        x-small
                      >
                        <v-avatar left x-small class="default">
                          <v-icon x-small>fa fa-eye</v-icon>
                        </v-avatar>
                        Opened
                      </v-chip>
                    </h5>
                  </router-link>
                  <p class="mfo">
                    <i class="far fa-clock" />
                    {{ unit.unit.video_duration }}
                  </p>
                  <p>
                    {{ unit.unit.description }}
                    <router-link
                      :to="{
                        name: 'UnitPage',
                        params: { id: unit.unit.id },
                      }"
                    >
                      <v-btn x-small text color="error">
                        Proceed to Unit
                      </v-btn>
                    </router-link>
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="togglePreviewDialog"> Close </v-btn>
        <v-btn color="primary" text @click="goToModules(moduleId)">
          Proceed to {{ isModulePage ? 'Module' : 'Category' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PreviewSeriesDialog',
  props: {
    moduleId: Number,
    series: Array,
    previewSeriesDialog: Boolean,
    togglePreviewDialog: Function,
    isModulePage: Boolean,
  },
  methods: {
    renderBanner(series) {
      if (!series.highlight_unit) {
        return series.units[0].unit;
      }

      let highlight = series.units.filter((unit) => {
        return unit.unit_id == series.highlight_unit;
      });

      return highlight[0].unit;
    },
    goToModules(id) {
      this.$router.push({
        name: this.isModulePage ? 'CertificationModulePage' : 'Course Page',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
